export default {
    GET_PRODUCTION_DEPARTMENTS_SUCCESS: (state, data) => {
        state.productionDepartments = data
    },

    GET_PRODUCTION_SITE_GROUPS_SUCCESS: (state, data) => {
        state.productionSiteGroups = data
    },

    GET_PRODUCTION_PROCESSES_SUCCESS: (state, data) => {
        state.productionProcesses = data
    },

    GET_MACHINES_SUCCESS: (state, data) => {
        state.machines = data
    },

    GET_REPORT_ITEMS_SUCCESS: (state, data) => {
        state.reportItems = data
    },

    GET_RESPONSIBLE_USERS_SUCCESS: (state, data) => {
        const map = new Map()

        state.responsibleUsers.forEach(user => {
            if (user && (user.id !== undefined && user.id !== null)) {
                map.set(user.id, user)
            }
        })

        data.forEach(user => {
            if (user && (user.id !== undefined && user.id !== null)) {
                map.set(user.id, user)
            }
        })

        state.responsibleUsers = Array.from(map.values())
    },

    GET_USERS_SUCCESS: (state, data) => {
        state.users = data
    },

    GET_ERROR_CODE_GROUPS_SUCCESS: (state, data) => {
        state.errorCodeGroups = data
    },

    GET_PROCEEDING_WAYS_SUCCESS: (state, data) => {
        state.proceedingWays = data
    },

    GET_STATUSES_SUCCESS: (state, data) => {
        state.statuses = data
    },
}
